import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, NextMove, useTitle } from '../components/Layout';
import { Piece } from '../components/Board';
import { useProgress, useVisit } from '../progress';
import { profile, scenarios } from '../data';

const ACTIONS = [
  { piece: 'R', title: 'Résumé', copy: 'The full record: experience, education and skills.', href: profile.resume, cta: 'Open résumé', external: true },
  { piece: 'Q', title: 'Email', copy: 'Send me a message and I will get back to you shortly.', href: `mailto:${profile.email}`, cta: profile.email },
  { piece: 'N', title: 'LinkedIn', copy: 'Connect with me and see my professional network.', href: profile.linkedin, cta: 'Connect', external: true },
  { piece: 'K', title: 'Book a call', copy: 'Schedule a time to chat about opportunities or projects.', href: profile.calendly, cta: 'Schedule a call', external: true },
];

export default function Endgame() {
  useTitle('Endgame');
  useVisit('endgame');
  const { title, puzzlesDone } = useProgress();

  return (
    <div className="page">
      <PageHeader index="04" eyebrow="Endgame" title="Your move.">
        Interested in working together, or have questions about my experience? Pick a square.
      </PageHeader>

      {title.name === 'Grandmaster' ? (
        <div className="banner">
          <span className="banner-piece">
            <Piece piece="K" />
          </span>
          <p>
            <strong>Grandmaster.</strong> You explored every section and completed every puzzle. The only thing left is
            to say hello.
          </p>
        </div>
      ) : (
        puzzlesDone < scenarios.length && (
          <p className="muted small">
            Still curious? There are unsolved puzzles waiting in the <Link to="/puzzles">puzzle room</Link>.
          </p>
        )
      )}

      <div className="actions">
        {ACTIONS.map((a) => (
          <a
            key={a.title}
            href={a.href}
            className="action"
            {...(a.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            <span className="action-piece">
              <Piece piece={a.piece} />
            </span>
            <span className="action-title">{a.title}</span>
            <span className="action-copy">{a.copy}</span>
            <span className="action-cta">
              {a.cta} <span aria-hidden="true">→</span>
            </span>
          </a>
        ))}
      </div>

      <NextMove current="/endgame" />
    </div>
  );
}
